module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-007"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("JOSHUA INSTRUCTIONS THE PEOPLE"), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Joshua+3%3A7-13&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("JOSHUA 3:7-13")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" The Jordan crossing manifests Joshua’s exaltation by the Lord through representing the mystery of baptism, a dispensation that assures us of God’s presence among us (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-028"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('b', [_vm._v("3:7-10 ")])]), _vm._v("The Lord Will Demonstrate His Presence")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSTERY OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APTISM")]), _vm._v(".")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": What great things were manifested before! The Red Sea was crossed on foot, manna was given from heaven, springs were burst open in the wilderness, the law was given through Moses. Many signs and marvels were performed in the wilderness, but nowhere is it said that Jesus [Joshua] was “exalted.” But where the Jordan is crossed, there it is said to Jesus [Joshua], “In this day I am beginning to exalt you in the sight of the people.” Indeed, Jesus is not exalted before the mystery of baptism. But his exaltation, even his exaltation in the sight of the people, assumes a beginning from then on. If “all who are baptized [into Christ Jesus] are baptized into his death,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN121",
      "id": "ap_part1_NFIN121-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" and the death of Jesus is made complete by the exaltation of the cross, deservedly then, Jesus is first exalted for each of the faithful when that person arrives at the mystery of baptism. Because thus it is written that “God exalted him and gave him a name that is above every name, that at the name of Jesus "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("every knee should bend, in heaven and on earth, and below the earth.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN122",
      "id": "ap_part1_NFIN122-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" 4.2."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN123",
      "id": "ap_part1_NFIN123-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APTIZED INTO")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS")]), _vm._v(".")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": And he commands the priests to go before the people with the ark of the covenant. It is then, too, that the mystery of the dispensation of the Father with the Son is manifested, since the Son is highly exalted by him who grants “that in the name of Jesus every knee should bow, of those that are in heaven, on earth, and under the earth; and that every tongue should confess that Jesus Christ is Lord, to the glory of God the Father.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN124",
      "id": "ap_part1_NFIN124-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These matters are revealed through the following words which have been recorded in the book of Joshua: “And the Lord said to Jesus [Joshua], ‘In this day I will begin to exalt you before the sons of Israel.’ ” We must also hear our Lord Jesus saying to the sons of Israel, “Come here and hear the Word of the Lord our God. In this you shall know that the living God is among you.” For by being baptized into Jesus we will know that the living God is among us. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 6.231-32."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN125",
      "id": "ap_part1_NFIN125-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-091d3380","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap7.vue
// module id = 99
// module chunks = 0